import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PayrollRun, PayrollRunCreate, PayrollRunFilter } from '../data/payrollRun';

export function createPayrollRunService(client: AxiosInstance) {
  return createCrudService<PayrollRun, PayrollRunCreate, PayrollRunFilter>(
    client,
    '/hrm/PayrollRun',
    'id',
  );
}

export type PayrollRunService = CrudService<PayrollRun, PayrollRunCreate, PayrollRunFilter>;
